import { type FC } from 'react';
import { type SecurePayAccessCode } from '@/api/registration/payment';
import { type CartDisplay } from '@/api/registration';
import { useRegisterSteps } from '@/registration/hook/useRegisterSteps';
import PayBySecurePayIframe from '@/registration/component/Register/Payment/PayBySecurePayIframe';

export interface PayBySecurePayProps {
  setErrors: React.Dispatch<React.SetStateAction<string[]>>
  options: SecurePayAccessCode
  isValid: boolean
}

const PayBySecurePay: FC<PayBySecurePayProps> = ({
  setErrors,
  options,
  isValid
}) => {
  const { toPaymentProcessingStep } = useRegisterSteps();

  const resultCallback = async () => {
    // Whether a transaction was processed. One of Complete, Cancel, or Error
    const additionalParams = { orderHash: options.order.secureHash };
    toPaymentProcessingStep(additionalParams);
  };

  return (
    <PayBySecurePayIframe
      setErrors={setErrors}
      isLoading={false}
      isDisabled={!isValid}
      orderId={options.order.id}
      clientId={options.clientId}
      merchantCode={options.merchantCode}
      resultCallback={resultCallback}
      testMode={options.testMode}
    />
  );
};

export default PayBySecurePay;
